var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{btn:true},style:({background:_vm.bgcolor,color:_vm.fcolor,width:_vm.btnsize})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }